import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledDosageTemplateReadOnly = styled(StyledFlex)`
   width: 100%;
`;

StyledDosageTemplateReadOnly.displayName = 'StyledDosageTemplateReadOnly';
